import { render, staticRenderFns } from "./cardIntegration.vue?vue&type=template&id=4aa98d63&scoped=true"
import script from "./cardIntegration.vue?vue&type=script&lang=js"
export * from "./cardIntegration.vue?vue&type=script&lang=js"
import style0 from "./cardIntegration.vue?vue&type=style&index=0&id=4aa98d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa98d63",
  null
  
)

export default component.exports